import React from 'react';
import { motion } from 'framer-motion';
import { FaChevronDown, FaRegImage } from 'react-icons/fa';

const QuietExperience = ({ modules, renderModules, giftIntro = {} }) => {
  const finalCards = modules.filter((module) => module.type === 'keepsake_poster');
  const storyModules = modules.filter((module) => module.type !== 'keepsake_poster');
  const hasFinalCard = finalCards.length > 0;
  const introTitle = giftIntro.title || 'Start with the card they can keep';
  const introCopy = giftIntro.subtitle ||
    'The final card becomes the cover, then the story behind it unfolds softly below.';

  return (
    <div className="space-y-10">
      <motion.div
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        className="lumirae-opening-card mx-4 text-center"
      >
        <div className="relative min-h-[360px] overflow-hidden p-7">
          <div className="absolute left-1/2 top-8 h-4 w-36 -translate-x-1/2 rounded-full bg-[#B7895E] shadow-lg" />
          <motion.div
            animate={{ y: [0, -6, 0], rotate: [0, -0.8, 0.8, 0] }}
            transition={{ duration: 5, repeat: Infinity, ease: 'easeInOut' }}
            className="relative mx-auto mt-10 flex h-48 w-36 flex-col items-center justify-center rounded-[1.6rem] border-4 border-white shadow-2xl"
            style={{ backgroundColor: 'var(--lumirae-surface-raised)' }}
          >
            <FaRegImage className="mb-4 text-4xl" style={{ color: 'var(--lumirae-accent-primary)' }} />
            <div className="h-2 w-20 rounded-full" style={{ backgroundColor: 'var(--lumirae-accent-soft)' }} />
            <div className="mt-3 h-2 w-14 rounded-full" style={{ backgroundColor: 'color-mix(in srgb, var(--lumirae-accent-soft) 70%, white)' }} />
            <div className="absolute -bottom-5 left-1/2 h-10 w-1 -translate-x-1/2 bg-[#B7895E]/40" />
          </motion.div>
          <div className="lumirae-opening-label relative mt-9">
            Keepsake Poster
          </div>
          <div className="lumirae-opening-title relative mx-auto mt-3 max-w-xs text-3xl leading-tight">
            {introTitle}
          </div>
          <p className="lumirae-opening-copy relative mx-auto mt-3 max-w-xs">
            {introCopy}
          </p>
          <div className="mt-6 grid grid-cols-3 gap-2">
            {['Save', 'Revisit', 'Remember'].map((label) => (
              <div
                key={label}
                className="rounded-full border border-white/80 bg-white/55 px-3 py-2 text-[8px] font-black uppercase tracking-[0.2em]"
                style={{ color: 'var(--lumirae-text-secondary)' }}
              >
                {label}
              </div>
            ))}
          </div>
        </div>
      </motion.div>

      {hasFinalCard && (
        <motion.div initial={{ opacity: 0, y: 18 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.15 }}>
          {renderModules(finalCards, 'full_page')}
        </motion.div>
      )}

      {storyModules.length > 0 && (
        <div className="lumirae-opening-card mx-4 p-5 text-center">
          <div className="lumirae-ds-meta">
            The Story Behind It
          </div>
          <p className="lumirae-opening-copy mx-auto mt-2 max-w-xs">
            Scroll down for the photos, letter, voice, and blessings that made this card.
          </p>
          <FaChevronDown className="mx-auto mt-4" style={{ color: 'var(--lumirae-accent-primary)' }} />
        </div>
      )}

      <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.25 }}>
        {renderModules(hasFinalCard ? storyModules : modules, 'quiet')}
      </motion.div>
    </div>
  );
};

export default QuietExperience;
